import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonCard, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonIcon, IonItem, IonLabel, IonProgressBar, IonText, IonToggle, popoverController } from '@ionic/vue';
import { computed, onMounted, ref } from 'vue';
import { storefrontOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { translate } from '@hotwax/dxp-components';
import OrderLimitPopover from '@/components/OrderLimitPopover.vue';
import { UtilService } from '@/services/UtilService';
import { hasError, showToast } from '@/utils';
import logger from '@/logger';
import { useStore } from 'vuex';
import emitter from '@/event-bus';
import { DateTime } from 'luxon';


export default /*@__PURE__*/_defineComponent({
  __name: 'FacilityItem',
  props: ["facility"],
  setup(__props) {

const router = useRouter();
const store = useStore();

const selectedPage = ref({
  path: '',
  name: ''
}) as any

const props = __props;
const facilities = computed(() => store.getters["util/getFacilities"]);
const pickupGroups = computed(() => store.getters["util/getPickupGroups"]);
const pickupGroupFacilities = computed(() => store.getters["util/getPickupGroupFacilities"]);

onMounted(() => {
    selectedPage.value.path = router.currentRoute.value.path
    selectedPage.value.name = router.currentRoute.value.name
})

async function changeOrderLimitPopover(ev: Event) {
  const popover = await popoverController.create({
    component: OrderLimitPopover,
    event: ev,
    showBackdrop: false,
    componentProps: {fulfillmentOrderLimit: props.facility.maximumOrderLimit}
  });
  popover.present();

  const result = await popover.onDidDismiss();
  // Note: here result.data returns 0 in some cases that's why it is compared with 'undefined'.
  if(result.data != undefined && result.data !== props.facility.maximumOrderLimit){
    await updateFacility(result.data)
  }
}

async function updateFacility(maximumOrderLimit: number | string) {
  let resp;

  emitter.emit("presentLoader");
  
  try {
    resp = await UtilService.updateFacility({
      ...props.facility,
      maximumOrderLimit
    })

    if(!hasError(resp)) {
      const updatedFacilities = JSON.parse(JSON.stringify(facilities.value))
      const currentFacility = updatedFacilities.find((facility: any) => facility.facilityId === props.facility.facilityId)
      currentFacility.maximumOrderLimit = maximumOrderLimit;

      showToast(translate("Order fulfillment capacity updated successfully"))
      await store.dispatch("util/updateFacilities", { facilities: updatedFacilities })
    } else {
      throw resp.data
    }
  } catch(err) {
    showToast(translate("Failed to update facility"))
    logger.error("Failed to update facility", err)
  }
  emitter.emit("dismissLoader");
}

function isPickupAllowed(group: any) {
  const facilities = pickupGroupFacilities.value[group.facilityGroupId]
  return facilities.find((facility: any) => facility.facilityId === props.facility.facilityId);
}

async function updatePickupAllowed(event: Event, group: any) {
  event.stopImmediatePropagation();

  let payload = {} as any;
  const isPickupActive = isPickupAllowed(group);

  if(isPickupActive) {
    const facilities = pickupGroupFacilities.value[group.facilityGroupId]
    payload = facilities.find((facility: any) => facility.facilityId === props.facility.facilityId)
    payload = {
      ...payload,
      thruDate: DateTime.now().toMillis()
    }
  } else {
    payload = {
      facilityId: props.facility.facilityId,
      facilityGroupId: group.facilityGroupId,
      fromDate: DateTime.now().toMillis()
    }
  }

  try {
    const resp = await UtilService.updateFacilityAssociationWithPickupGroup(payload)
    if(!hasError(resp)) {
      const facilitiesByPickupGroup = JSON.parse(JSON.stringify(pickupGroupFacilities.value));
      if(isPickupActive) {
        facilitiesByPickupGroup[group.facilityGroupId] = facilitiesByPickupGroup[group.facilityGroupId].filter((record: any) => record.facilityId !== props.facility.facilityId);
      } else {
        facilitiesByPickupGroup[group.facilityGroupId].push(payload)
      }
      store.dispatch("util/updatePickupGroupFacilities", facilitiesByPickupGroup);
      showToast(translate("Facility association updated successfully with pickup group."))
    } else {
      throw resp.data;
    }
  } catch(error: any) {
    logger.error(error);
    showToast(translate("Failed to update facility association with pickup group."));
  }
  
}

return (_ctx: any,_cache: any) => {
  return (selectedPage.value.path === '/store-pickup')
    ? (_openBlock(), _createBlock(_unref(IonCard), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), { class: "overline" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.facility.facilityId), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.facility.facilityName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pickupGroups.value, (group) => {
            return (_openBlock(), _createBlock(_unref(IonItem), {
              lines: "none",
              key: group.facilityGroupId
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), {
                  icon: _unref(storefrontOutline),
                  slot: "start"
                }, null, 8, ["icon"]),
                _createVNode(_unref(IonToggle), {
                  checked: isPickupAllowed(group),
                  onClick: _withModifiers(($event: any) => (updatePickupAllowed($event, group)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(group.facilityGroupName ? group.facilityGroupName : group.facilityGroupId), 1)
                  ]),
                  _: 2
                }, 1032, ["checked", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_unref(IonCard), { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardSubtitle), { class: "overline" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.facility.facilityId), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.facility.facilityName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (__props.facility.maximumOrderLimit === 0)
            ? (_openBlock(), _createBlock(_unref(IonItem), {
                key: 0,
                lines: "none"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(translate)("orders in fulfillment queue", {orderCount: __props.facility.orderCount})), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonChip), {
                    outline: true,
                    onClick: changeOrderLimitPopover,
                    color: "danger",
                    fill: "outline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.facility.maximumOrderLimit), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (__props.facility.maximumOrderLimit)
              ? (_openBlock(), _createBlock(_unref(IonItem), {
                  key: 1,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonText), { slot: "start" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.facility.orderCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonProgressBar), {
                      value: __props.facility.orderCount / __props.facility.maximumOrderLimit
                    }, null, 8, ["value"]),
                    _createVNode(_unref(IonChip), {
                      slot: "end",
                      outline: true,
                      onClick: changeOrderLimitPopover
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.facility.maximumOrderLimit), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonItem), {
                  key: 2,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("orders allocated today", {orderCount: __props.facility.orderCount})), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonChip), {
                      outline: true,
                      onClick: changeOrderLimitPopover
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(translate)("Unlimited")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
        ]),
        _: 1
      }))
}
}

})